


























import { Component, Prop, Vue } from 'vue-property-decorator';
import CoinIcon from '@/components/icons/WidgetCoin.vue';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';

@Component({
  components: {
    CoinIcon,
    Typography
  }
})
export default class CoinNetworkFeatureTag extends Vue {
  @Prop({}) featureName!: string;

  dataTippy = `coin-network-feature-${Math.floor(
    Math.random() * 10
  )}${Math.floor(Math.random() * 10)}`;
}
